var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-headful',{attrs:{"title":"Адміністратори випускного іспиту"}}),_c('admin-final-exam-admin-list-index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }